/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';
import {PeriodTypeInfoChartModel} from '../../../models/period-type-info-chart/period-type-info-chart.model';
import {TableService} from '../../../../shared/table/table-service/table.service';
import {DatepickerHelperService} from '../../../../shared/utils/datepicker-helper/datepicker-helper.service';
import {BundlesConfigService} from '../../../services/bundles-config.service';
import {TimePeriodBaseModel} from '../../../models/period/time-period-base/time-period-base.model';
import {PeriodViewTabsEnum} from '../../../bundles-main-page/data/period-view-tabs.enum';
import {PeriodsViewsService} from '../../../services/periods-views/periods-views.service';

@Component({
    selector: 'app-period-type-info-chart',
    templateUrl: './period-type-info-chart.component.html',
    styleUrls: ['./period-type-info-chart.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PeriodTypeInfoChartComponent<Enum, DataObject> implements AfterViewInit {
    @Input() periodTypeInfoChartData = new Map<string, PeriodTypeInfoChartModel>();
    @Input() showBundles = false;
    public periodViewTabs = PeriodViewTabsEnum;

    constructor(private tableService: TableService<Enum, DataObject>,
                private cd: ChangeDetectorRef,
                private bundlesConfigService: BundlesConfigService,
                private periodsViewsService: PeriodsViewsService) {
    }

    get hasPeriodTypeInfoChartData(): boolean {
        return this.periodTypeInfoChartData?.size > 0;
    }

    get currentView(): PeriodViewTabsEnum {
        return this.periodsViewsService.getCurrentView();
    }

    get hasNoResultBody(): boolean {
        return this.periodsViewsService.isGlobalSearchCriteriaApplied();
    }

    originalOrder(): number {
        return 0;
    }

    ngAfterViewInit(): void {
        this.tableService.getOpenLineHeightValue()
                .subscribe((value) => {
                    if (value.height != null && value.identifier != null) {
                        const el = document.querySelector(`[lineIdentifier=${value.identifier}]`);
                        el?.setAttribute('style', `height: ${value.height}px`);
                    }
                });
        this.cd.detectChanges();
    }

    periodDateTooltip(date: TimePeriodBaseModel): string {
        if (date != null && this.bundlesConfigService.timezone != null) {
            return `From: ${DatepickerHelperService.convertTimestampToDateAndTime(date?.startDate, this.bundlesConfigService.timezone,
                            'DD-MM-YYYY')} to: ` +
                    `${DatepickerHelperService.convertTimestampToDateAndTime(date?.endDate, this.bundlesConfigService.timezone,
                            'DD-MM-YYYY')}`;
        }
    }

    periodChartLineDataCy(index: number): string {
        if (index != null) {
            return `period-chart-line-${index}`;
        }
    }

    getLineIdentifier(bundle: string): string {
        if (bundle != null) {
            return `id-${bundle}`;
        }
    }
}
